import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import './App.css';
import Router from './Router';
import {
  NotificationsActiveOutlined,
  SettingsOutlined,
  TrendingUpOutlined,
  ShoppingCartOutlined,
  LocalShippingOutlined,
  AccountBalanceOutlined,
  InsightsOutlined,
  HistoryOutlined,
} from '@mui/icons-material';

const notificationIcon = <NotificationsActiveOutlined className="text-white" />;
const adminIcon = <SettingsOutlined style={{ color: '#ffbe5f' }} />;
const historyIcon = <TrendingUpOutlined className="text-white" />;
const demandIcon = <ShoppingCartOutlined className="text-white" />;
const supplyIcon = <LocalShippingOutlined className="text-white" />;
const hedgesIcon = <AccountBalanceOutlined className="text-white" />;
const strategyIcon = <InsightsOutlined className="text-white" />;
const activityIcon = <HistoryOutlined className="text-white" />;

export const globalMenuItems = [
  // Main menu items
  { name: 'Dashboard', link: '/dashboard' },
  { name: 'Historical prices', link: '/historical-prices', icon: historyIcon },
  { name: 'Demand', link: '/demand', icon: demandIcon },
  { name: 'Sales commitments', link: '/sales-commitments', isSalesCommitment: 1 },
  { name: 'Supply', link: '/Supply', icon: supplyIcon },
  { name: 'Hedges', link: '/hedges', icon: hedgesIcon },
  { name: 'Strategy & Insights', link: '/strategy', icon: strategyIcon },
  // { name: 'Upload Files', link: '/upload-files' },
  { name: 'Notifications', link: '/notifications', icon: notificationIcon },
  { name: 'Activity', link: '/activity', icon: activityIcon },

  // Admin section — single hub page
  { name: 'Admin', link: '/admin', isAdminOnly: true, icon: adminIcon },

  // { name: 'Quotes', link: '/client-order' },
  // { name: 'Settings', link: '/products-dashboard' },
  // { name: 'Builder', link: '/policy' },
  // { name: 'Policy', link: '/policy/material' },
  // { name: 'Account', link: 'unauthorized' },
  // { name: 'Performance', link: '/route-optimization' },
  // { name: 'Routes optimization', link: '/opportunity', isAdminOnly: true },
];

document.addEventListener('DOMContentLoaded', () => {
  const ogUrlMeta = document.querySelector('meta[property="og:url"]');
  if (ogUrlMeta) {
    const path = window.location.pathname?.match(/^\/([^/]+)/)?.[0] || '';
    console.log('url', window.location.origin + path);
    ogUrlMeta.setAttribute('content', window.location.origin + path);
  }
});

const queryClient = new QueryClient();

function App() {
  return (
    <div className="App w-screen h-screen overflow-x-hidden overflow-y-hidden bg-light-blue 	">
      <QueryClientProvider client={queryClient}>
        <Router />
        <ReactQueryDevtools />
      </QueryClientProvider>
    </div>
  );
}

export default App;
